import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const accommodationCommandSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("ACCOMMODATION_EDIT_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    providerId: providerIdZodSchema,
    productId: productIdZodSchema,

    resources: z.array(resourceIdZodSchema),

    rates: z.array(z.any()),
});

type AccommodationEditCommand = z.infer<typeof accommodationCommandSchema>;

type CreateParams = Except<
    AccommodationEditCommand,
    "_id" | "_type" | "_createdAt"
>;

const accommodationEditFactory = (params: CreateParams) => {
    const editCommand: AccommodationEditCommand = {
        ...params,
        _id: generateId({
            prefix: "command__",
        }),
        _type: "ACCOMMODATION_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return editCommand;
};

export { accommodationCommandSchema, accommodationEditFactory };
export type { AccommodationEditCommand };
